<template>
  <div id="subject">
    <!-- 专题详情 -->
    <!-- <div class="banner">
      <div class="con">
        <router-link v-if="subject.thumbs" :to="{path:`/${global.year}/teacher`,name:`Teacher${global.year}`,query:{id:subject.producerId}}">
          <div class="img" :style="'background:url(' + getUrl(subject.thumbs) +') no-repeat center center;'">
            <img :src="getUrl(subject.thumbs)" alt="">
          </div>
        </router-link>
        <div class="img" v-if="!subject.thumbs" style="background:url(http://vip.msup.com.cn/index.php/xin-bin-api/head?url=https%3A%2F%2Ff.msup.com.cn%2Fhead.jpeg&size=600x600) no-repeat center center;"></div>
        <div class="text">
          <p class="title">专题出品人：<span>{{subject.name!=name ? name : (subject.name||"敬请期待")}}</span></p>
          <p class="desc">{{subject.company}}&nbsp;&nbsp;{{subject.position}}</p>
          <p class="desc">{{subject.ldesc}}</p>
        </div>
      </div>
    </div> -->
    <div class="banner" v-if="subject.producers && subject.producers.length > 0">
      <div class="con" v-for="(item,index) in subject.producers" :key="'producers'+index">
        <div class="img" :style="item.thumbs?`--producer-thumbs-url: url(${global.formatThumbs(item.thumbs)})`:''">
          <img v-if="item.thumbs" :src="global.formatThumbs(item.thumbs)" alt="">
        </div>
        <div class="text">
          <p class="title">专题出品人：<span>{{item.name || "敬请期待"}}</span></p>
          <p class="desc">{{item.company}}&nbsp;&nbsp;{{item.position}}</p>
          <p class="desc">{{item.ldesc}}</p>
        </div>
      </div>
    </div>
    <div class="banner" v-else-if="subject.id">
      <div class="con">
        <div class="img"></div>
        <div class="text">
          <p class="title">专题出品人：<span>敬请期待</span></p>
          <p class="desc"></p>
          <p class="desc"></p>
        </div>
      </div>
    </div>
    <div class="banner_bottom">
      <div class=con>
        <div class="text">
          <p>专题：{{subject.venueName || '神秘议题'}}</p>
          <!-- <p v-if="subject.ldesc">{{subject.ldesc}}</p> -->
        </div>
        <div class="clearboth"></div>
      </div>
    </div>
    <div class="sub">
      <div class="con_top mob">本专题下的议题</div>
      <!-- pc -->
      <div class="con pc">
        <div class="course" v-for="(item,index) in subject.courses" :key="'course_item'+index">
          <div class="left">
            <div class="text">
              <p v-if="item.name || (item.lecturers && item.lecturers[0] && item.lecturers[0].name)"
              >by <span>{{item.name || (item.lecturers && item.lecturers[0] && item.lecturers[0].name) || ''}}</span></p>
              <p>{{item.company || (item.lecturers && item.lecturers[0] && item.lecturers[0].company) || ''}}<br>{{item.position || (item.lecturers && item.lecturers[0] && item.lecturers[0].position) || ''}}</p>
            </div>
          </div>
          <div class="right">
            <h1>
              <router-link v-if="item.courseid||item.courseId" :to="{path:`/${global.year}/course`,name:`Course${global.year}`,query:{id:item.courseid||item.courseId}}">{{item.courseTitle}}</router-link>
              <a v-else>{{item.courseTitle}}</a>
            </h1>
            <slot v-if="item.desc || item.profit || item.courseDesc">
              <h2 v-if="item.desc">课程概要</h2>
              <p v-if="item.desc">{{item.desc}}</p>
              <h2 v-if="item.profit">听众收益</h2>
              <p v-if="item.profit">{{item.profit}}</p>
              <p v-if="item.courseDesc">{{item.courseDesc}}</p>
            </slot>
          </div>
        </div>
      </div>
      <!-- mob  -->
      <div class="con mob">
        <div v-for="(item,index) in subject.courses" :key="'course_item'+index" :class="`course course_${index}${item.showMob?' is-show':''}`">
          <!-- <div class="left top" @click="(item.courseid||item.courseId) ? (item.showMob=!item.showMob,showDetail(item.showMob,index)) : ''"> -->
          <div class="left top" @click="(item.desc || item.profit || item.courseDesc)?showDetail(index):''">
            <div class="text">
              <!-- <router-link :to="{path:`/${global.year}/course`,name:`Course${global.year}`,query:{id:item.courseid||item.courseId}}"> -->
                <h1>{{item.courseTitle}}</h1>
                <p v-if="item.name || (item.lecturers && item.lecturers[0] && item.lecturers[0].name)"
                >by <span>{{item.name || (item.lecturers && item.lecturers[0] && item.lecturers[0].name) || ''}}</span></p>
                <p>{{item.company || (item.lecturers && item.lecturers[0] && item.lecturers[0].company) || ''}}&nbsp;&nbsp;&nbsp;{{item.position || (item.lecturers && item.lecturers[0] && item.lecturers[0].position) || ''}}</p>
              <!-- </router-link> -->
            </div>
          </div>
          <div class="right bottom" v-if="item.desc || item.profit || item.courseDesc">
            <h2 v-if="item.desc">课程概要</h2>
            <p v-if="item.desc">{{item.desc}}</p>
            <h2 v-if="item.profit">听众收益</h2>
            <p v-if="item.profit">{{item.profit}}</p>
            <p v-if="item.courseDesc">{{item.courseDesc}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="other" v-if="subject.venues && subject.venues.length > 0">
      <div class="con">
        <h1>相关专题</h1>
        <!-- <h1>相关案例</h1> -->
        <div class="case">
          <ul>
            <router-link v-for="(item,index) in subject.venues" :key="'sub_venues'+index" 
              :to="{path:`/${global.year}/subject`,name:`Subject${global.year}`,query:{id:item.id}}">
              <div class="content">
                <!-- <img src="../../public/img/logo.png" alt="" /> -->
                <p class="name">{{item.producers || '敬请期待'}}</p>
                <p class="company">{{item.company || '敬请期待'}}<br />{{item.position || '敬请期待'}}</p>
              </div>
              <p class="case-title">
                {{item.venueName}}
              </p>
            </router-link>
          </ul>
        </div>
        <div class="clearboth"></div>
        <div class="bot"></div>
      </div>
    </div>
    <div class="other" v-else style="padding:0;">
      <div class="con">
        <div class="bot" style="height:0;"></div>
      </div>
    </div>
    <!-- card -->
    <!-- <Card v-if="$route.query.card" :_kind="'subject'" :_info="subject"></Card> -->
    <card-index v-if="$route.query.card" :_kind="'subject'" :_info="subject"></card-index>
  </div>
</template>

<script>
import $ from "jquery";
import {sid, scheduledifference, getLecturerInfo, getSpeechThemeInfo, getSueArr, getSueType, scheduleDifferenceId} from "@/utils/api.js";
import mixinSchedule from '@/utils/mixinSchedule.js'

export default {
  name:"Subject",
  mixins: [mixinSchedule],
  props: {
    mstarttime: {
      type: [Number, String],
      default: '',
    },
    mendtime: {
      type: [Number, String],
      default: '',
    },
    mplace: {
      type: [Number, String],
      default: '',
    },
  },
  data(){
    let _this = this;
    return {
      params:'',
      subject:{},
      name:'',
      // show:[],
      // differenceKey: '',
      // scheduleDifference: scheduledifference(_this.global.year),
    }
  },
  computed: {
    scheduleData () {
      return { address: this.mplace, endTime: this.mendtime, startTime: this.mstarttime }
    }
  },
  methods:{
    showDetail (index) {
      if (this.subject && this.subject.courses && this.subject.courses[index]) {
        this.subject.courses[index].showMob = !this.subject.courses[index].showMob
        this.$forceUpdate()
      }
    },
    _showDetail: function(b,i){
      // console.log(this.subject.courses[i],this.subject.courses[i].showMob);
      // console.log(e);
      // for(let s=0;s<$(".con.mob .course").length;s++){
      //   this.show[s] = false;
      // }
      // this.show[i] = !this.show[i];
      // console.log($(".con.mob .course_"+i+" .bottom").css);
      // $(".con.mob .course_"+i+" .bottom").css = "display:block;"
      if(b){
        $(".con.mob .course_"+i+" .top").css({'background':'#dfe2eb','border-color':'#999999'});
        $(".con.mob .course_"+i+" .bottom").css({'visibility':'visible','max-height':'2000px','padding-bottom':'35px'});
        $(".con.mob .course_"+i+" .bottom *").css({'visibility':'visible'});
      } else {
        $(".con.mob .course_"+i+" .top").css({'background':'#ffffff','border-color':'#003177'});
        $(".con.mob .course_"+i+" .bottom").css({'visibility':'hidden','max-height':'0','padding-bottom':'0'});
        $(".con.mob .course_"+i+" .bottom *").css({'visibility':'hidden'});
      }
    },
    getUrl: function(str){
      // "[{"fileUrl":"https:\/\/f.msup.com.cn\/loEV_IvMHXqpRB8xxWfUFcN8DPI3.jpg",
      //    "thumbnailUrl":"https:\/\/f.msup.com.cn\/loEV_IvMHXqpRB8xxWfUFcN8DPI3.jpg?imageMogr2\/crop\/!2765x2765a346a922"}]"
      let url = typeof str==='string' && str.includes('fileUrl') ? 
        str.split('fileUrl":"')[1].split('","')[0].replace(/\\/g, '') : 
        '';
      return url;
    },
    getSubject() {
      // console.log(this.params.id);
      var url = getSpeechThemeInfo + this.params.id;
      // var _this = this;
      this.$http
        .jsonp(url)
        .then(data => {
          return data.json();
        })
        .then(data => {
          if(data.errno == 0){
            // console.log("Subject data: ",data.data);
            this.subject = data.data;
            for(let s=0;s<data.data.courses.length;s++){
              // this.show[s] = false;
              this.subject.courses[s].showMob = false;
            }
            // 出品人
            if(data.data.producerId){
              this.$http
                .jsonp(`${getLecturerInfo}/${sid(this.global.year)}/${data.data.producerId}`)
                .then((res) => {
                  return res.json();
                })
                .then((res) => {
                  if(res.errno == 0){
                    this.name = res.data.name;
                  }
                })
            }
            // 相关专题
            for(let v=0;v<data.data.venues.length;v++){
              this.subject.venues[v].producers = this.subject.venues[v].producers || '';
              this.subject.venues[v].company = '敬请期待';
              this.subject.venues[v].position = '敬请期待';
              this.$http
                .jsonp(`${getSpeechThemeInfo}${data.data.venues[v].id}`)
                .then((tres) => {
                  return tres.json();
                })
                .then((tres) => {
                  if(tres.errno == 0){
                    // this.subject.venues[v].producers = this.subject.venues[v].producers || tres.data.name || '敬请期待';
                    this.subject.venues[v].producers = this.subject.venues[v].producers || tres.data.name || '敬请期待';
                    this.subject.venues[v].company = tres.data.company || '敬请期待';
                    this.subject.venues[v].position = tres.data.position || '敬请期待';
                    // 
                  }
                })
            }
            // console.log('venues ', this.subject.venues)
            // 特殊排课
            this.getDifference();
          }
        })
    },
    _getSubject: function(){
      // console.log(this.params.id);
      var url = getSpeechThemeInfo + this.params.id;
      // var _this = this;
      this.$http
        .jsonp(url)
        .then(data => {
          return data.json();
        })
        .then(data => {
          if(data.errno == 0){
            // console.log("Subject data: ",data.data);
            this.subject = data.data;
            for(let s=0;s<data.data.courses.length;s++){
            //   this.show[s] = false;
              this.subject.courses[s].showMob = false;
            }
            // 出品人name -》 嘉宾name
            if(data.data.producerId){
              this.$http
                .jsonp(`${getLecturerInfo}/${sid(this.global.year)}/${data.data.producerId}`)
                .then((res) => {
                  return res.json();
                })
                .then((res) => {
                  if(res.errno == 0){
                    this.name = res.data.name;

                    // 相关专题 -》 专题 题目、出品人、公司、职位
                    // $(".other .case ul").remove();
                    for(let v=0;v<data.data.venues.length;v++){
                      // 
                      this.subject.venues[v].company = '敬请期待';
                      this.$http
                        .jsonp(`${getSpeechThemeInfo}${data.data.venues[v].id}`)
                        .then((tres) => {
                          return tres.json();
                        })
                        .then((tres) => {
                          if(tres.errno == 0){
                            this.subject.venues[v].company = 'new';
                            // console.log("Subject sub: ",this.subject);

                            let style_a = "cursor: pointer;display: flex;flex-direction: column-reverse;padding: 22px 22px 21px 20px;margin: 12.5px;text-decoration: none;text-align: left;background: #ffffff;border: 1px solid #d6dce3;";
                            // if( (v+1)%3==0 ){
                            //   style_a += "margin-right: 0;"
                            // }
                            // if( (v+1)%3==2 ){
                            //   style_a += "margin-left: 0;margin-right: 0;"
                            // }
                            let style_div = "border-top: 1px solid #d6dce3;padding-top: 36px;padding-left: 9px;width: 340px;";
                            let style_p1 = "font-size: 18px;font-family: PingFang SC;font-weight: bold;color: #484848;margin-bottom: 6px;";
                            let style_p2 = "font-size: 14px;font-family: PingFang SC, PingFang SC-Regular;color: #3e3a39;line-height: 16px;";
                            let style_p3 = "width: 305px;padding-left: 7px;padding-bottom: 10px;line-height: 25px;font-weight: 500;font-size: 18px;font-family: PingFang SC;color: #003177;";
                            // let style_mob = "@media(max-width:750px){a{width: 90%;padding: 13px!important;} p{font-size: 13px!important;}}"
                            $(".other .case ul").append(`
                              <a style="${style_a}" href="/subject?id=${data.data.venues[v].id}">
                                <div class="content" style="${style_div}">
                                  <p class="name" style="${style_p1}">${
                                    this.subject.venues[v].producers ? 
                                    this.subject.venues[v].producers : (
                                    tres.data.name || '敬请期待'
                                  )}</p>
                                  <p class="company" style="${style_p2}">
                                    ${tres.data.company?tres.data.company:'敬请期待'} <br> ${tres.data.position?tres.data.position:'敬请期待'}
                                  </p>
                                </div>
                                <p class="case-title" style="${style_p3}">${this.subject.venues[v].venueName}</p>
                              </a>
                            `);
                          }
                        });
                    }

                  }
                });
            } else {
              // 相关专题 -》 专题 题目、出品人、公司、职位
              // $(".other .case ul").remove();
              for(let v=0;v<data.data.venues.length;v++){
                // 
                this.subject.venues[v].company = '敬请期待';
                this.$http
                  .jsonp(`${getSpeechThemeInfo}${data.data.venues[v].id}`)
                  .then((tres) => {
                    return tres.json();
                  })
                  .then((tres) => {
                    if(tres.errno == 0){
                      this.subject.venues[v].company = 'new';
                      // console.log("Subject sub: ",this.subject);
                      let style_a = "cursor: pointer;display: flex;flex-direction: column-reverse;padding: 22px 22px 21px 20px;margin: 12.5px;text-decoration: none;text-align: left;background: #ffffff;border: 1px solid #d6dce3;";
                      // if( (v+1)%3==0 ){
                      //   style_a += "margin-right: 0;"
                      // }
                      // if( (v+1)%3==2 ){
                      //   style_a += "margin-left: 0;margin-right: 0;"
                      // }
                      let style_div = "border-top: 1px solid #d6dce3;padding-top: 36px;padding-left: 9px;width: 340px;";
                      let style_p1 = "font-size: 18px;font-family: PingFang SC;font-weight: bold;color: #484848;margin-bottom: 6px;";
                      let style_p2 = "font-size: 14px;font-family: PingFang SC, PingFang SC-Regular;color: #3e3a39;line-height: 16px;";
                      let style_p3 = "width: 305px;padding-left: 7px;padding-bottom: 10px;line-height: 25px;font-weight: 500;font-size: 18px;font-family: PingFang SC;color: #003177;";
                      // let style_mob = "@media(max-width:750px){a{width: 90%;padding: 13px!important;} p{font-size: 13px!important;}}"
                      $(".other .case ul").append(`
                        <a style="${style_a}" href="/subject?id=${data.data.venues[v].id}">
                          <div class="content" style="${style_div}">
                            <p class="name" style="${style_p1}">
                              ${this.subject.venues[v].producers?this.subject.venues[v].producers:'敬请期待'}
                            </p>
                            <p class="company" style="${style_p2}">
                              ${tres.data.company?tres.data.company:'敬请期待'} <br> ${tres.data.position?tres.data.position:'敬请期待'}
                            </p>
                          </div>
                          <p class="case-title" style="${style_p3}">${this.subject.venues[v].venueName}</p>
                        </a>
                      `);
                    }
                  });
              }
            }
            // 特殊排课
            // this.get_Difference();
          }
        })
    },
    getProducer (index) {
      console.log(index, this.subject.producers[index])
      /* 》》》》》》
      company: "腾讯云"
      ldesc: "..."
      name: "黄世飞"
      position: "副总裁"
      thumbs: ""
      */
    },
    // 特殊排课的专题  this.subject.date this.subject.groupId this.subject.times
    formatDifferenceKey(date, groupid, times) {
      let theDate = this.global.formatTime(date, 'YMD')
      let startDate = this.global.formatTime(this.scheduleData.startTime, 'YMD');
      let endDate = this.global.formatTime(this.scheduleData.endTime, 'YMD');
      let day = theDate>=startDate && theDate<endDate ? 1 : 2;
      let index = times.slice(0,2)<'12' ? 0 : 1;
      // 
      let period = index===0||index===1 ? ['am', 'pm'][index] : ''
      let key = `${this.global.year}_${day}_${groupid}_${period}`
      return key;
    },
    // isDifference(date, groupid, times) {
    //   let flag = false;
    //   if(this.scheduleDifference && typeof this.scheduleDifference==='object') {
    //     let key = this.formatDifferenceKey(date, groupid, times);
    //     let keys = Object.keys(this.scheduleDifference);
    //     if(keys.includes(key)) {
    //       flag = true;
    //     }
    //   }
    //   return flag;
    // },
    _getDifference() {
      let url = getSueType + scheduleDifferenceId;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          // console.log("difference ", res);
          if (res.errno == 0 && res.data) {
            let type = '';
            let typeList = [];
            for(let item of res.data) {
              type = item.typeName && typeof item.typeName==='string' && item.typeName.toLocaleLowerCase();
              if(type && type.includes('giac')) {
                typeList.push({id:item.id, name:type.split('#')[1]});
              }
            }
            this.differenceKey = this.formatDifferenceKey(this.subject.date, this.subject.groupId, this.subject.times);
            for(let item of typeList) {
              if(item.name === this.differenceKey) {
                this.getScheduleDifference(item);
              }
            }
          }
        })
    },
    _getScheduleDifference(typeItem) {
      this.scheduleDifference[typeItem.name].courses = [];
      let url = getSueArr + scheduleDifferenceId;
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          // console.log("difference ", res);
          if (res.errno == 0 && res.data) {
            if(this.scheduleDifference[typeItem.name]) {
              this.scheduleDifference[typeItem.name].courses = [];
              this.scheduleDifference[typeItem.name].timeStamp = new Date().getTime();
              let course = {}, lecturers=[], lecturer='', times=[], titles=[], title='';
              for(let index in res.data[0]) {
                let course = res.data[0][index];
                // console.log(course);
                // schedule-difference
                lecturers = course.content && course.content.length>0 && course.content.split(' /// ');
                if(course.content_note && course.content_note.length>0) {
                  times = (course.content_note.split('scheduleTitle--')[0] || '').replace('time--','').replace(/\r\n/g,'').split('-');
                  // titles = (course.content_note.split('scheduleTitle--')[1] || '').replace(/^\r\n/,'').split('\r\n');
                }
                this.scheduleDifference[typeItem.name].courses.push({
                  courseTitle: course.title,
                  courseid: '',
                  date: this.subject.date,
                  desc: '',
                  profit: '',
                  character: '',
                  name: lecturers[0].split(' || ')[0] && lecturers[0].split(' || ')[0]!=='客户技术高层' ? lecturers[0].split(' || ')[0] : '',
                  company: lecturers[0].split(' || ')[0] && lecturers[0].split(' || ')[0]!=='客户技术高层' && lecturers[0].split(' || ')[1] ? lecturers[0].split(' || ')[1] : '',
                  position: lecturers[0].split(' || ')[0] && lecturers[0].split(' || ')[0]!=='客户技术高层' && lecturers[0].split(' || ')[2] ? lecturers[0].split(' || ')[2] : '',
                  startTime: times[0],
                  endTime: times[1],
                  training: null,
                  showMob: false,
                });
                // for(let lindex in lecturers) {
                //   lecturer = lecturers[lindex] || '';
                //   // title = titles[lindex] || '';
                //   if(lecturer.split(' || ')[0] && lecturer.split(' || ')[0].trim() !== '客户技术高层') {
                //     this.scheduleDifference[typeItem.name].courses[index].lecturers.push({
                //       name: lecturer.split(' || ')[0] || '',
                //       company: lecturer.split(' || ')[1] || '',
                //       position: lecturer.split(' || ')[2] || '',
                //       // courseTitle: title, // 不需要显示讲师议题
                //     });
                //   }
                // }
              }
            }
            this.subject.courses = [ ...this.scheduleDifference[typeItem.name].courses ];
            this.$forceUpdate();
          }
        })
    },
    // 
    formatSubject (data) {
      // console.log('scheduleDifference', data, this.subject, this.params)
      if (this.params.id && this.subject.id) {
        // 常规生成的专题，只是排课方式特殊，如正常一个专题4节课，但本专题有5节专题
        // date groupId times
        this.subject.date = this.subject.date.toString().trim()
        let dates = this.subject.venues.map(item => item.date.toString().trim())
        dates = dates.sort()
        const d = dates.indexOf(this.subject.date) + 1
        const g = this.subject.groupId
        const p = this.getPeriod(this.subject.times)
        const dKey = this.setDifferenceKey(d, g, p)
        if (data[dKey]) {
          this.subject.courses = data[dKey].courses || []
        }
      } else if (this.params.d) {
        // 未进行常规生成、额外存在的专题，如正常有5个分组，对应半日内有5个专题，但本专题顺序在第6(5+1)
        const {d, g, p} = this.params
        const dKey = this.setDifferenceKey(d, g, p)
        if (data[dKey]) {
          // console.log('dKey', dKey, data[dKey])
          this.subject.venueName = data[dKey].vName || ''
          this.subject.courses = data[dKey].courses || []
          this.subject.producerId = data[dKey].producersId || ''
          this.subject.producers = data[dKey].producersId ? data[dKey].producersId.split(',').map(id => {id}) : []
          for (let lIindex in this.subject.producers) {
            this.getProducer(lIindex)
          }
        }
      }
    }
  },
  created(){
    this.params = this.$route.query;
    if (this.params.id) {
      this.getSubject()
    } else if (this.params.d) {
      this.getDifference()
    }
    // for(let s=0;s<$(".con.mob .course").length;s++){
    //   this.show[s] = false;
    // }
  },
  moubted(){
    // this.getSubject();
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.query.id != from.query.id){
        this.params = this.$route.query;
        if (this.params.id) {
          this.getSubject()
        } else if (this.params.d) {
          this.getDifference()
        }
      }
    },
    scheduleDifference: {
      handler (newValue, oldValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.formatSubject(newValue)
        }
      },
      deep: true,
      immediate: true,
    }
  },
  components: {
    CardIndex: () => import('../components/Card/Index.vue'),
  },
}
</script>

<style lang="scss">
*{
  font-size: 14px;
  text-align: left;
  margin: 0;
  padding: 0;
}
a,
a:hover,
a:visited {
  color: #337ab7;;
  text-decoration: none;
}
// div
h1,h2,h3,h4,h5,h6,p,a,span,b,i,em,div {
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
}
.pc{
  display: block;
}
.mob{
  display: none;
}

#subject {
  // margin-top: 135px;
  text-align: left;
  .banner {
    // margin-top: 135px;
    width: 100%;
    min-height: 305px;
    background: #fafbfc;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .con{
      width: 100%;
      max-width: 1110px;
      margin: 0 auto;
      padding: 43px 0;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .img{
        width: 193px;
        min-width: 193px;
        height: 211px;
        margin-right: 60px;
        // float: left;
        border-radius: 7px;
        --producer-thumbs-url: url('http://vip.msup.com.cn/index.php/xin-bin-api/head?url=https%3A%2F%2Ff.msup.com.cn%2Fhead.jpeg&size=600x600');
        background: var(--producer-thumbs-url) no-repeat center center;
        background-size: 100% 100%!important;
        overflow: hidden;
        img {
          width: 193px;
          height: 211px;
          object-position: top;
          object-fit: cover;
        }
      }
      .text{
        padding-top: 20px;
        .title,.title span{
          font-size: 36px;
          font-family: PingFang SC Bold;
          font-weight: bold;
          color: #003177;
          line-height: 22px;
          span{
            font-weight: 400;
            color: #212121;
          }
        }
        .title span{
          font-family: PingFang SC Regular;
        }
        .desc{
          font-size: 16px;
          font-family: PingFang SC Regular;
          font-weight: 400;
          color: #999999;
          line-height: 22px;
        }
        .desc:nth-of-type(2){
          padding: 22px 0;
          margin-top: 5px;
        }
        .desc:nth-of-type(3){
          line-height: 30px;
        }
      }
    }
  }
  .banner_bottom{
    width: 100%;
    // min-height: 357px;
    background: #ffffff;
    .con{
      max-width: 1142px;
      margin: 0 auto;
      .text{
        max-width: 790px;
        margin-left: 330px;
        padding-top: 85px;
        padding-bottom: 85px;
        p{
          font-size: 16px;
          font-family: PingFang SC Regular;
          font-weight: 400;
          color: #999999;
          line-height: 30px;
        }
        p:first-of-type{
          font-size: 36px;
          color: #505050;
          padding-bottom: 60px;
        }
      }
    }
  }
  .sub{
    width: 100%;
    background: #fafbfc;
    padding-top: 96px;
    padding-bottom: 64px;
    .con_top{
      width: 100%;
      padding: 15px 0;
      color: #ffffff;
      background: #293F76;
      line-height: 20px;
      font-size: 15px;
      font-family: PingFang SC Bold;
      font-weight: bold;
      text-align: center;
    }
    .con.mob{
      .course{
        border: none;
        .left.top{
          border-left: 8px solid #003177;
          -webkit-transition: all 1.2s;
          -moz-transition: all 1.2s;
          -o-transition: all 1.2s;
          transition: all 1.2s;
          display: block;
          width: 100%!important;
          margin: 0;
          padding: 32px 5%;
          background: #ffffff;
          border-color: #003177;
          .text{
            h1{
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #1F64AF;
              line-height: 22px;
              padding-bottom: 18px;
              margin-bottom: 0;
            }
            p,p *{
              font-size: 13px!important;
              line-height: 14px;
              white-space: pre-wrap;
            }
            p:nth-of-type(1){
              padding-bottom: 13px;
            }
          }
        }
        .bottom{
          border-left: 8px solid #003177;
          -webkit-transition: all 1s;
          -moz-transition: all 1s;
          -o-transition: all 1s;
          transition: all 1s;
          width: 100%!important;
          overflow: hidden;
          margin: 0;
          padding: 32px 5%;
          padding-top: 0px;
          visibility: hidden;
          max-height: 0;
          padding-bottom: 0;
          *{
            -webkit-transition: all 1s;
            -moz-transition: all 1s;
            -o-transition: all 1s;
            transition: all 1s;
            visibility: hidden;
          }
          h2{
            font-size: 16px;
            padding-bottom: 20px;
          }
          p{
            font-size: 15px;
          }
        }
        &.is-show {
          .top {
            background: #dfe2eb;
            border-color: #999999;
          }
          .bottom {
            visibility: visible;
            max-height: 2000px;
            padding-bottom: 35px;
            * {
              visibility: visible;
            }
          }
        }
      }
    }
    .con.pc{
      .course{
        display: flex!important;
      }
    }
    .con{
      max-width: 1142px;
      margin: 0 auto;
      .course{
        width: 100%;
        background: #ffffff;
        border-left: 8px solid #003177;
        margin-bottom: 40px;
        .left{
          flex: none;
          width: 240px;
          align-items:center;
          display: flex;
          display: -webkit-flex;
          margin-left: 37px;
          margin-right: 45px;
          .text{
            margin: auto 0;
            p{
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 24px;
              margin-bottom: 0;
            }
            p:nth-of-type(1),p:nth-of-type(1) *{
              font-size: 18px;
              font-weight: 500;
              line-height: 29px;
              color: #131313;
              padding-bottom: 10px;
              margin-bottom: 0;
            }
            p:nth-of-type(1) span{
              color: #1F64AF;
            }
          }
        }
        .right{
          padding-top: 56px;
          padding-bottom: 53px;
          margin-right: 30px;
          h1,h1 *{
            font-size: 30px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #1F64AF;
            line-height: 32px;
            padding-bottom: 45px;
            margin-bottom: 0;
            cursor: pointer;
          }
          h2{
            font-size: 18px;
            font-family: PingFang SC Medium;
            font-weight: 500;
            color: #131313;
            line-height: 29px;
            padding: 25px 0;
            margin-bottom: 0;
          }
          p{
            white-space: pre-line;
            font-size: 16px;
            font-family: PingFang SC Regular;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .other{
    width: 100%;
    background: #ffffff;
    padding-top: 86px;
    .con{
      // max-width: 1225px;
      max-width: 1250px;
      margin: 0 auto;
      h1{
        width: 100%;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #003177;
        padding-bottom: 50.5px;
        margin-top: 0;
        margin-bottom: 0;
      }
      .case{
        // max-width: 1225px;
        max-width: 1250px;
        margin: 0 auto;
        ul{
          padding-bottom: 43px;
          margin-bottom: 0;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-evenly;
          a:hover {
            box-shadow: 0px 0px 8px 0px rgba(72, 75, 77, 0.1);
          }
          a {
            padding: 22px 22px 21px 20px;
            margin: 12.5px;
            text-decoration: none;
            text-align: left;
            display: flex;
            flex-direction: column-reverse;
            justify-content: space-between;
            background: #ffffff;
            border: 1px solid #d6dce3;
            .case-title {
              width: 305px;
              padding-left: 7px;
              padding-bottom: 10px;
              margin-top: 0;
              margin-bottom: 0;
              line-height: 25px;
              font-weight: 500;
              font-size: 18px;
              font-family: PingFang SC;
              color: #003177;
            }
            .content {
              border-top: 1px solid #d6dce3;
              padding-top: 36px;
              padding-left: 9px;
              width: 340px;
              img {
                width: 69px;
                height: 13px;
              }
              p {
                margin-top: 0;
                margin-bottom: 0;
              }
              .name {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #484848;
                margin-bottom: 6px;
              }
              .company {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                color: #3e3a39;
                line-height: 16px;
              }
            }
          }
          // a:nth-child(3n) {
          //   margin-right: 0;
          // }
        }
      }
      .bot{
        max-width: 1200px;
        margin: 0 12.5px;
        height: 102.5px;
        border-bottom: 1px solid #e1e1e1;
      }
    }
  }
}


.clearboth {
  clear: both;
  float: none !important;
  width: 0 !important;
  height: 0 !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

@media (max-width: 1200px) {
  #subject {
    .banner {
      height: auto!important;
      .con {
        // width: 90%;
        padding-left: 5%;
        padding-right: 5%;
        .text {
          .title {
            line-height: 42px!important;
          }
        }
      }
    }
    .banner_bottom{
      height: auto!important;
      .con{
        width: 90%;
      }
    }
    .sub{
      .con{
        width: 90%;
      }
    }
  }
}

// @media (max-width: 750px) {
@media (max-width: 767px) {
  #subject {
    .pc {
      display: none!important;
    }
    .mob {
      display: block!important;
    }
    .banner {
      height: auto!important;
      .con {
        // width: 85%;
        padding-left: 7.5%;
        padding-right: 7.5%;
        display: block;
        .img {
          width: 32vw!important;
          min-width: 0!important;
          height: 34vw!important;
          max-width: 135px!important;
          max-height: 145px!important;
          float: none!important;
          margin: 0!important;
          margin: 0 auto!important;
          img {
            width: 32vw!important;
            height: 34vw!important;
            max-width: 135px!important;
            max-height: 145px!important;
          }
        }
        .text {
          padding-top: 25px!important;
          .title,.title * {
            font-size: 15px!important;
          }
          .title {
            line-height: 22px!important;
            text-align: center;
            margin-bottom: 0;
          }
          .desc {
            font-size: 13px!important;
            line-height: 24px!important;
            color: #4c4c4c!important;
            margin-bottom: 0;
          }
          .desc:nth-of-type(2) {
            padding-top: 5px!important;
            padding-bottom: 16px!important;
            text-align: center!important;
            color: #293F76!important;
            font-family: PingFang SC Medium!important;
            font-weight: 500!important;
            margin: 0!important;
          }
        }
      }
    }
    .banner_bottom{
      // min-height: 0px;
      .con{
        width: 85%!important;
        .text{
          padding-top: 45px!important;
          padding-bottom: 45px!important;
          margin-left: 0!important;
          p{
            font-size: 15px!important;
            line-height: 23px!important;
            margin-bottom: 0;
            &:first-of-type{
              font-size: 18px!important;
              line-height: 22px!important;
              padding-bottom: 24px!important;
            }
          }
        }
      }
    }
    .sub{
      padding: 0!important;
      .con{
        padding-top: 35px;
        padding-bottom: 15px!important;
        .course{
          margin-bottom: 15px!important;
        }
      }
    }
    .other{
      padding-top: 45px!important;
      .con{
        .bot{
          height: 35px!important;
        }
        h1{
          padding-bottom: 24px!important;
          font-size: 18px!important;
        }
        .case{
          *{
            font-size: 15px!important;;
          }
          ul{
            a{
              width: 90%;
              padding: 13px!important;
              .content{
                width: 100%!important;
                padding-top: 18px!important;
                img{
                  width: 60px!important;
                  height: 12px!important;
                }
                p{
                  font-size: 13px!important;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 540px) { }
</style>